


















































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import NcpTable from '@/components/table/NcpTable.vue';
import {toI18n} from '@/utils/commonUtils';
import {range} from '@/utils/dateUtils';
@Component({
  metaInfo() {
    return (this as any).viewTitle;
  },
  components: {
    PageTitle,
    NcpTable
  }
})
export default class FeePolicyGuide extends Vue {
  private get viewTitle() {
    let title = this.$t('FEE_GUIDE_TITLE');
    return {title};
  }

  private exampleNoticeData = range(1, 4).map(num => `FEE_GUIDE_EXAMPLE_NOTICE_${num}`);

  private settlementCriteriaTableData = {
    colWidths: ['200px'],
    tbodyHead: ['FEE_GUIDE_DIVISION', 'FEE_GUIDE_CONTENT'],
    tbodyContent: [
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_APPLY_RATE')},
          {
            content: `<ul>
                      <li>${this.toI18n('FEE_GUIDE_APPLY_RATE_CONTENT_1')}</li>
                      <li>${this.toI18n('FEE_GUIDE_APPLY_RATE_CONTENT_2')}</li>
                    </ul>`,
            style: 'text-align: left;',
            isHtml: true,
          },
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXTRA_SERVICE_USE')},
          {
            content: `<ul>
                    <li>${this.toI18n('FEE_GUIDE_EXTRA_SERVICE_CONTENT')}</li>
                  </ul>`,
            style: 'text-align: left;',
            isHtml: true,
          },
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_SPECIAL_DISCOUNT')},
          {
            content: `<ul>
                    <li>${this.toI18n('FEE_GUIDE_SPECIAL_DISCOUNT_CONTENT_1')}</li>
                    <li>${this.toI18n('FEE_GUIDE_SPECIAL_DISCOUNT_CONTENT_2')}</li>
                  </ul>`,
            style: 'text-align: left;',
            isHtml: true,
          },
        ]
      },
      {
        tdData: [
          {
            content: this.toI18n('FEE_GUIDE_ADJUST_DISCOUNT')
          },
          {
            content: `<ul>
                    <li>${this.toI18n('FEE_GUIDE_ADJUST_DISCOUNT_CONTENT_1')}</li>
                    <li>${this.toI18n('FEE_GUIDE_ADJUST_DISCOUNT_CONTENT_2')}</li>
                  </ul>`,
            style: 'text-align: left;',
            isHtml: true,
          },
        ]
      },
    ]
  };

  private finalSettlementExampleTableData = {
    tbodyHead: ['FEE_GUIDE_USE_PERIOD','FEE_GUIDE_MALL_NAME','FEE_GUIDE_SETTLEMENT_PRICE','FEE_GUIDE_FINAL_SETTLEMENT_PRICE'],
    tbodyContent: [
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_A')},
          {content: '367,500'},
          {
            content: `800,000${this.toI18n('FEE_GUIDE_MONEY_UNIT')}`,
            class: 'orange'
          }
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_B')},
          {content: '16,000,000'},
          {content: `16,000,000${this.toI18n('FEE_GUIDE_MONEY_UNIT')}`}
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_C')},
          {content: '19,800,000'},
          {
            content: this.toI18n('FEE_GUIDE_FEE_EXEMPTION'),
            class: 'skyblue'
          }
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_D')},
          {content: '31,050,000'},
          {
            content: `30,000,000${this.toI18n('FEE_GUIDE_MONEY_UNIT')}`,
            class: 'pink'
          }
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_E')},
          {content: '120,000'},
          {
            content: `300,000${this.toI18n('FEE_GUIDE_MONEY_UNIT')}`,
            class: 'lightgreen'
          }
        ]
      },
    ]
  };

  private detailSettlementExampleTableData = {
    tbodyHead: [
      'FEE_GUIDE_USE_PERIOD',
      'FEE_GUIDE_MALL_NAME',
      'FEE_GUIDE_TOTAL_SALES',
      'FEE_GUIDE_NCP_RATE',
      'FEE_GUIDE_EXTRA_SERVICE',
      'FEE_GUIDE_EXTRA_SERVICE_DC_RATE',
      'FEE_GUIDE_SPECIAL_DISCOUNT_D',
      'FEE_GUIDE_ADJUST_DISCOUNT_E',
      'FEE_GUIDE_FINAL_APPLY_RATE'
    ],
    tbodyContent: [
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_A')},
          {content: '15,000,000'},
          {content: '2.5%'},
          {content: `1${this.toI18n('FEE_GUIDE_COUNT')}`},
          {content: '0.05%'},
          {content: '-'},
          {content: '-'},
          {content: '2.45%'},
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_B')},
          {content: '800,000,000'},
          {content: '2.2%'},
          {content: `2${this.toI18n('FEE_GUIDE_COUNT')}`},
          {content: '0.15%'},
          {content: '-'},
          {content: '0.05%'},
          {content: '2.0%'},
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_C')},
          {content: '1,100,000,000'},
          {content: '2.0%'},
          {content: `4${this.toI18n('FEE_GUIDE_COUNT')}`},
          {content: '0.2%'},
          {content: this.toI18n('FEE_GUIDE_FEE_EXEMPTION')},
          {content: '-'},
          {content: '1.8%'},
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_D')},
          {content: '2,300,000,000'},
          {content: '1.5%'},
          {content: `2${this.toI18n('FEE_GUIDE_COUNT')}`},
          {content: '0.15%'},
          {content: '-'},
          {content: ''},
          {content: '1.35%'},
        ]
      },
      {
        tdData: [
          {content: this.toI18n('FEE_GUIDE_EXAMPLE_YEAR_MONTH')},
          {content: this.toI18n('FEE_GUIDE_MALL_E')},
          {content: '6,000,000'},
          {content: '2.0%'},
          {content: '-'},
          {content: '-'},
          {content: '-'},
          {content: '-'},
          {content: '2.0%'},
        ]
      },
    ]
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  private onClickClose() {
    window.close();
  }
}
